const STORAGE_KEY = "employer-token"
const TOKEN_PARAM = "t"

// O t= do descadastro é outro token: só tira um e-mail da lista, não abre tela nenhuma da empresa.
// Guardá-lo como sessão mandaria um token que o authorizer recusa em toda chamada do portal.
const ROTAS_SEM_SESSAO = ["/descadastro"]

// O acesso do RH é sem cadastro: o token assinado chega no link do e-mail mensal, com validade.
// Ao abrir a página ele sai da barra de endereço e passa a viver na sessão da aba — o link é
// encaminhado (para o contador, para o sócio, para o grupo do WhatsApp) e um token exposto no
// histórico, no print ou no Referer é o jeito mais fácil de vazá-lo sem ninguém perceber.
export const captureToken = (): string | null => {
    const url = new URL(window.location.href)
    if (ROTAS_SEM_SESSAO.includes(url.pathname.replace(/\/+$/, ""))) return getToken()

    const fromLink = url.searchParams.get(TOKEN_PARAM)

    if (fromLink) {
        sessionStorage.setItem(STORAGE_KEY, fromLink)
        url.searchParams.delete(TOKEN_PARAM)
        window.history.replaceState({}, "", url.toString())
        return fromLink
    }

    return sessionStorage.getItem(STORAGE_KEY)
}

export const getToken = (): string | null => sessionStorage.getItem(STORAGE_KEY)

export const clearToken = () => sessionStorage.removeItem(STORAGE_KEY)
